import { useContext } from "react";
import { SearchParamsContext } from "~/contexts/search_params_context";

export const useSearchParams = () => useContext(SearchParamsContext);
